/**
 * @generated SignedSource<<ea0f5c7bb82d891f4c50006bee34a2ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type cacMonthPanel_Query$variables = {
  month: string;
};
export type cacMonthPanel_Query$data = {
  readonly cacMonthBreakdown: {
    readonly components: ReadonlyArray<{
      readonly key: string;
      readonly label: string;
      readonly subcategories: ReadonlyArray<{
        readonly key: string;
        readonly label: string;
        readonly totalSpend: number;
        readonly transactions: ReadonlyArray<{
          readonly category: {
            readonly name: string;
          } | null | undefined;
          readonly counterparty: {
            readonly name: string;
          } | null | undefined;
          readonly description: string;
          readonly postingDate: any;
          readonly spend: number;
          readonly txn: {
            readonly id: string;
          } | null | undefined;
        }>;
      }>;
      readonly totalSpend: number;
    }>;
    readonly month: string;
  };
};
export type cacMonthPanel_Query = {
  response: cacMonthPanel_Query$data;
  variables: cacMonthPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "month"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSpend",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spend",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  (v11/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cacMonthPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CacMonthBreakdown",
        "kind": "LinkedField",
        "name": "cacMonthBreakdown",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CacMonthComponent",
            "kind": "LinkedField",
            "name": "components",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CacMonthSubcategory",
                "kind": "LinkedField",
                "name": "subcategories",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CacMonthTxn",
                    "kind": "LinkedField",
                    "name": "transactions",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CacRef",
                        "kind": "LinkedField",
                        "name": "counterparty",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CacRef",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cacMonthPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CacMonthBreakdown",
        "kind": "LinkedField",
        "name": "cacMonthBreakdown",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CacMonthComponent",
            "kind": "LinkedField",
            "name": "components",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CacMonthSubcategory",
                "kind": "LinkedField",
                "name": "subcategories",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CacMonthTxn",
                    "kind": "LinkedField",
                    "name": "transactions",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CacRef",
                        "kind": "LinkedField",
                        "name": "counterparty",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CacRef",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b83dc5f6ec523987df601ab259db1de",
    "id": null,
    "metadata": {},
    "name": "cacMonthPanel_Query",
    "operationKind": "query",
    "text": "query cacMonthPanel_Query(\n  $month: String!\n) {\n  cacMonthBreakdown(month: $month) {\n    month\n    components {\n      key\n      label\n      totalSpend\n      subcategories {\n        key\n        label\n        totalSpend\n        transactions {\n          postingDate\n          description\n          spend\n          txn {\n            id\n          }\n          counterparty {\n            name\n            id\n          }\n          category {\n            name\n            id\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "25e8bd98acc7d862a0f326edabeac457";

export default node;
